"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _order = require("@tajawal/ct-web-payment-sdk/lib/stores/api/order.store");
var _downloadOrderPdf = require("@tajawal/web-payment-sdk-v2/lib/stores/download-order-pdf.store");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _is_after = _interopRequireDefault(require("date-fns/is_after"));
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _constants2 = require("../constants");
var _bookings = require("../utils/bookings.utils");
var _class; // stores
// @TODO when we update sdk on desktop & mweb update this to myaccount skd order store
// utils
// constants
/**
 * ManageFlightBookingPageStore
 */
let ManageFlightBookingPageStore = (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function ManageFlightBookingPageStore(initialState = {}, $env) {
    (0, _classCallCheck2.default)(this, ManageFlightBookingPageStore);
    this.$env = $env;
    this.updateInitialState(initialState);
    this.order = new _order.OrderStore(initialState.order, $env);
    this.orderPdf = new _downloadOrderPdf.DownloadOrderPdfStore(initialState.orderPdf, $env);
  }

  /**
   * update initial state
   * @param {Object} initialState
   */
  (0, _createClass2.default)(ManageFlightBookingPageStore, [{
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }

    /**
     * language
     * @return {string}
     */
  }, {
    key: "language",
    get: function () {
      return this.$env.config.language;
    }

    /**
     * Flight Product
     * @return {Object}
     */
  }, {
    key: "flightProduct",
    get: function () {
      return this.order.flightProduct;
    }

    /**
     * Flight Itinerary
     * @return {Object}
     */
  }, {
    key: "itinerary",
    get: function () {
      return this.flightProduct.itinerary;
    }

    /**
     * Flight Resource Codes
     * @return {Array}
     */
  }, {
    key: "resourceCodes",
    get: function () {
      return (0, _get2.default)(this.flightProduct, 'resourceCodes', []);
    }

    /**
     * Flight Amenities Codes
     * @return {Array}
     */
  }, {
    key: "amenitiesCodes",
    get: function () {
      return (0, _get2.default)(this.itinerary, 'amenitiesCodes', []);
    }

    /**
     * Refund Info Payload
     * @return {Object}
     */
  }, {
    key: "refundInfoPayload",
    get: function () {
      return {
        itineraryId: this.itinerary.id,
        travellers: this.flightProduct.searchRequest.pax,
        chunkId: null
      };
    }

    /**
     * Fare Rules Payload
     * @return {Object}
     */
  }, {
    key: "fareRulesPayload",
    get: function () {
      return {
        cartId: this.order.modifiedCartId,
        productId: this.flightProduct.id,
        isV3: this.flightProduct.isV3Pricing,
        fareUuid: this.flightProduct.fareUuid,
        vendor: this.flightProduct.vendor,
        airline: this.flightProduct.itinerary.validatingCarrier
      };
    }

    /**
     * Search results page Url
     * @return {string}
     */
  }, {
    key: "searchUrl",
    get: function () {
      return (0, _client.replaceParams)(_constants.APP_ROUTES.FLIGHTS_RESULTS, {
        language: this.language,
        query: this.flightProduct.query
      });
    }

    /**
     * hotel city code
     * @return {string}
     */
  }, {
    key: "hotelCityCode",
    get: function () {
      return (0, _get2.default)(this.flightProduct, 'searchRequest.goingLeg.destinationId');
    }

    /**
     * is past trip
     * @return {boolean}
     */
  }, {
    key: "isPastTrip",
    get: function () {
      return (0, _is_after.default)(new Date(), (0, _get2.default)(this.flightProduct, 'lastDepartureDate'));
    }

    /**
     * is processing
     * @return {boolean}
     */
  }, {
    key: "isProcessing",
    get: function () {
      return !this.isTripCompleted && !(0, _includes2.default)(_constants2.FLIGHT_BOOKING_STATUS, this.order.status);
    }

    /**
     * is confirmed
     * @return {boolean}
     */
  }, {
    key: "isConfirmed",
    get: function () {
      return _constants2.FLIGHT_BOOKING_STATUS.SUCCESS === this.order.status;
    }

    /**
     * is Cancellation Under Processing
     * @return {boolean}
     */
  }, {
    key: "isCancellationUnderProcessing",
    get: function () {
      return _constants2.FLIGHT_BOOKING_STATUS.CANCEL_ON_PROCESSING === this.order.status;
    }

    /**
     * is cancelled
     * @return {boolean}
     */
  }, {
    key: "isCancelled",
    get: function () {
      return [_constants2.FLIGHT_BOOKING_STATUS.CANCELLED, _constants2.FLIGHT_BOOKING_STATUS.REFUNDED, _constants2.FLIGHT_BOOKING_STATUS.MANUALLY_CANCELLED].includes(this.order.status);
    }

    /**
     * is Failed
     * @return {boolean}
     */
  }, {
    key: "isFailed",
    get: function () {
      return _constants2.FLIGHT_BOOKING_STATUS.FAILURE === this.order.status;
    }

    /**
     * is Trip Completed
     * @return {boolean}
     */
  }, {
    key: "isTripCompleted",
    get: function () {
      return !this.isCancelled && !this.isFailed && this.isPastTrip;
    }

    /**
     * has ETicket
     * @return {boolean}
     */
  }, {
    key: "hasETicket",
    get: function () {
      return (this.isConfirmed || this.isTripCompleted) && !!this.orderPdf.flightTicket;
    }

    /**
     * has Invoice
     * @return {boolean}
     */
  }, {
    key: "hasInvoice",
    get: function () {
      return !this.isProcessing && !this.isFailed && !!this.orderPdf.flightInvoiceUrl;
    }

    /**
     * has Airline Reference
     * @return {boolean}
     */
  }, {
    key: "hasAirlineReference",
    get: function () {
      return !this.isProcessing && !this.isFailed && !!this.flightProduct.airlineReference;
    }

    /**
     * has Rebook Option
     * @return {boolean}
     */
  }, {
    key: "hasRebookOption",
    get: function () {
      return this.isCancelled || this.isTripCompleted;
    }

    /**
     * Order Status State
     * @return {Object}
     */
  }, {
    key: "orderStatusState",
    get: function () {
      return {
        isProcessing: this.isProcessing,
        isConfirmed: this.isConfirmed,
        isCancellationUnderProcessing: this.isCancellationUnderProcessing,
        isCancelled: this.isCancelled,
        isFailed: this.isFailed,
        isPastTrip: this.isPastTrip,
        isTripCompleted: this.isTripCompleted
      };
    }
  }, {
    key: "bookingTagStatus",
    get: function () {
      return (0, _bookings.getBookingTagStatus)(this.order.data.displayStatus);
    }
  }]);
  return ManageFlightBookingPageStore;
}(), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "language", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "language"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "flightProduct", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "flightProduct"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "itinerary", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "itinerary"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resourceCodes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "resourceCodes"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "amenitiesCodes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "amenitiesCodes"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "refundInfoPayload", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "refundInfoPayload"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "fareRulesPayload", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "fareRulesPayload"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "searchUrl"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hotelCityCode", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hotelCityCode"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isPastTrip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPastTrip"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isProcessing", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isProcessing"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isConfirmed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isConfirmed"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isCancellationUnderProcessing", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCancellationUnderProcessing"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isCancelled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCancelled"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFailed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFailed"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isTripCompleted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isTripCompleted"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasETicket", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasETicket"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasInvoice", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasInvoice"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasAirlineReference", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasAirlineReference"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasRebookOption", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasRebookOption"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "orderStatusState", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderStatusState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "bookingTagStatus", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "bookingTagStatus"), _class.prototype)), _class);
exports.default = ManageFlightBookingPageStore;